import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import { Button, ButtonToolbar, Col, Modal, ModalBody, ModalHeader, Row } from 'reactstrap';
import { change } from 'redux-form';
import { connect } from 'react-redux';
import { GRL_URL } from '../../../../../../../utils/pnd/PndConstants';
import AddLocationAltIcon from '@mui/icons-material/AddLocationAlt';
import renderToggleButtonField from 'src/shared/components/form/ToggleButton';
import renderSelectField from 'src/shared/components/form/Select';
import { isNumber, mobileNoFormat, mobileNoLength, validateUaeLandline } from 'src/utils/validationUtils';

const required = value => value ? undefined : 'Required'
const renderField = ({ input, label, placeholder, type, meta: { touched, error, warning }, disabled }) => (
    <div className="form__form-group">
        <div className="form__form-group">
            <input
                {...input}
                  className="custom-placeholder"
                placeholder={placeholder}
                type={type}
                disabled={disabled}  // Add the disabled prop here
            />
            {touched && ((error && <span className="form__form-group-error"> {label} {error}</span>) || (warning && <span>{warning}</span>))}
        </div>
    </div>
)
const CustomerAddOrUpdate = ({ handleSubmit, setMapData, address, status, dispatch, setMapInfo, dataInfo, addressType }) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isAddress, setAddress] = useState(null);
    const [apaIframeUrl] = useState(GRL_URL);
    const apaFrameRef = useRef(null);
    const toggleModal = () => {
        setIsModalOpen(!isModalOpen);
    };

    const handleFindLocation = () => {
        toggleModal(); // Open the modal
        handleMessageToIframe(); // Send message to iframe
    };



    const handleMessageToIframe = () => {
        dispatch(change('CustomerAddOrUpdateForm', 'buildingName', ""));
        const datajson = '{"RequestID": ' + Math.floor((Math.random() * 20) + 1) + ',"MessageType":1,"AddressElements": [{"AddressElementTypeCode": 1,"Value":""},{"AddressElementTypeCode":2,"Value": ""},{ "AddressElementTypeCode": 3,"Value": ""},{"AddressElementTypeCode":4,"Value": ""},{"AddressElementTypeCode": 5,"Value":"520950"},{"AddressElementTypeCode": 6,"Value":"" },{"AddressElementTypeCode": 7, "Value": "" },{"AddressElementTypeCode": 8,"Value":""}]}';
        if (apaFrameRef.current) {
            apaFrameRef.current.contentWindow.postMessage(datajson, '*');
            window.addEventListener('message', handleMessageFromIframe);
        } else {
            console.error('iframe element not found');
        }
    };

    let deliveryAddress = "";
    const handleMessageFromIframe = (event) => {
        if (event && event.data) {
            try {
                const jsonRegex = /^\s*(\{.*\}|\[.*\])\s*$/;
                if (jsonRegex.test(event?.data)) {
                    const data_from_apa = JSON.parse(event.data);
                    setMapInfo(data_from_apa);
                    const buildingName = data_from_apa.AddressElements.find(element => element.AddressElementTypeCode === 6);
                    const landmark = data_from_apa.AddressElements.find(element => element.AddressElementTypeCode === 4);
                    const street = data_from_apa.AddressElements.find(element => element.AddressElementTypeCode === 3);
                    const area = data_from_apa.AddressElements.find(element => element.AddressElementTypeCode === 2);
                    const zone = data_from_apa.AddressElements.find(element => element.AddressElementTypeCode === 7);
                    const city = data_from_apa.AddressElements.find(element => element.AddressElementTypeCode === 8);
                    const emirates = data_from_apa.AddressElements.find(element => element.AddressElementTypeCode === 1);

                    if (buildingName && buildingName?.Value !== "") {
                        deliveryAddress = deliveryAddress + buildingName.Value + ",";
                        dispatch(change('CustomerPrimaryAddressBookAddOrUpdateForm', 'buildingName', buildingName.Value));
                    }
                    if (buildingName?.Value === "" && landmark?.Value !== "") {
                        deliveryAddress = deliveryAddress + landmark.Value + ",";
                    }
                    if (street) {
                        deliveryAddress = deliveryAddress + street.Value + ",";
                    }
                    if (area) {
                        deliveryAddress = deliveryAddress + area.Value + ",";
                    }
                    if (zone) {
                        deliveryAddress = deliveryAddress + zone.Value + ",";
                    }
                    if (city) {
                        deliveryAddress = deliveryAddress + city.Value + ",";
                    }
                    if (emirates) {
                        deliveryAddress = deliveryAddress + emirates.Value;
                    }
                    if (deliveryAddress && deliveryAddress.includes(",,")) {
                        setAddress(deliveryAddress.replace(/,,/g, ','));
                        setMapData(deliveryAddress.replace(/,,/g, ','));
                    }
                    // Close the modal after getting the address
                    toggleModal();
                }
            } catch (error) {
                console.error('event.data is not a valid JSON string');
            }
        }
    };


    return (
        <form className="form-animated" onSubmit={handleSubmit}>
            <Col lg={12} md={12}>

                <Row>
                    <Col lg={6} md={6}>
                        <div className="form__form-animated-group">
                            <span className='required_field'>* </span><span className="form__form-animated-group-label">Customer Name</span>
                            <div className="form__form-group-field">
                                <Field name="customerName" component={renderField} type="text" placeholder="Customer Name" validate={[required]} />
                            </div>
                        </div>
                    </Col>
                    <Col lg={6} md={6}>
                        <div className="form__form-animated-group">
                            <span className="form__form-animated-group-label">Contact Name</span>
                            <div className="form__form-group-field">
                                <Field name="contactName" component={renderField} type="text" placeholder="Contact Name" />
                            </div>
                        </div>
                    </Col>

                </Row>
                <Row>
                    <Col lg={6} md={6}>
                        <div className="form__form-animated-group">
                            <span className='required_field'>* </span>  <span className="form__form-animated-group-label">Mobile Number</span>
                            <div className="form__form-group-field">
                                <Field name="mobileNo" component={renderField} type="text" placeholder="Mobile No." validate={[required, mobileNoFormat, mobileNoLength]} />
                            </div>
                        </div>
                    </Col>


                    <Col lg={6} md={6}>
                        <div className="form__form-animated-group">
                            <span className="form__form-animated-group-label">LandLine No.</span>
                            <div className="form__form-group-field">
                                <Field name="telephoneNo" component={renderField} type="text" placeholder="LandLine No" validate={[isNumber, validateUaeLandline]} />
                            </div>
                        </div>
                    </Col>
                </Row>
                <Row>
                    {dataInfo &&
                        <Col lg={6} md={6}>
                            <div className="form__form-animated-group">
                                <span className='required_field'>* </span>  <span className="form__form-animated-group-label">Customer Code</span>
                                <div className="form__form-group-field">
                                    <Field name="merchantCustomerCode" component={renderField} type="text" placeholder="Customer Code" validate={[required]} disabled={true} />
                                </div>
                            </div>
                        </Col>
                    }

                </Row>
                <Row>
                    <Col md={3} lg={3}>
                        <div className="form__form-animated-group">
                            <span className="required_field">* </span>{" "}
                            <span className="form__form-animated-group-label">
                                Address Label
                            </span>
                            <div className="form__form-animated-group-field">

                                <Field
                                    validate={[required]}
                                    name="addressBookName"
                                    component={renderSelectField}
                                    type="text"
                                    options={[
                                        { value: 1, label: "Home" },
                                        { value: 2, label: "Work" },
                                        { value: 3, label: "Other" },
                                    ]}
                                    label="Address Label"
                                    placeholder="Label"

                                />

                            </div>
                        </div>
                    </Col>

                    <Col md={9} lg={9}>
                        <div className="form__form-animated-group">
                            <span className="required_field">* </span>{" "}
                            <span className="form__form-animated-group-label">
                                Address
                            </span>
                            <div className="form__form-animated-group-field">

                                <input
                                    validate={required}
                                    component="textarea"
                                    name="address"
                                    type="text"
                                    value={isAddress || address}
                                    label="Customer Address"
                                    placeholder="Customer Address"
                                />
                                <AddLocationAltIcon color="success" fontSize="large" style={{ cursor: 'pointer' }} onClick={handleFindLocation} />
                            </div>
                        </div>
                    </Col>
                    {/* <Col md={4} lg={4}>
                        <div className="form__form-animated-group">
                            <span className="required_field">* </span>{" "}
                            <span className="form__form-animated-group-label">
                                Pick Up Point GRC
                            </span>
                            <div className="form__form-animated-group-field">
                                <Field
                                    component={renderField}
                                    name="address"
                                    type="text"
                                    disabled={true}

                                />

                            </div>
                        </div>
                    </Col> */}
                    {/* GRC - 17 digit number */}
                </Row>
                <Row>
                    <Col lg={6} md={6}>
                        <div className="form__form-animated-group">
                            <span className='required_field'>* </span>  <span className="form__form-animated-group-label">Building Name</span>
                            <div className="form__form-group-field">
                                <Field name="buildingName" component={renderField} type="text" placeholder="Building Name" validate={[required]} />
                            </div>
                        </div>
                    </Col>
                    <Col lg={6} md={6}>
                        <div className="form__form-animated-group">
                            <span className="form__form-animated-group-label">PO Box No.</span>
                            <div className="form__form-group-field">
                                <Field name="poBoxNo" component={renderField} type="text" placeholder="PO Box No." validate={[isNumber]} />
                            </div>
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col lg={6} md={6}>
                        <div className="form__form-animated-group">
                            <span className='required_field'>* </span>  <span className="form__form-animated-group-label">Floor Number</span>
                            <div className="form__form-group-field">
                                <Field name="floorNo" component={renderField} type="text" placeholder="Floor Number" validate={[required]} />
                            </div>
                        </div>
                    </Col>
                    <Col lg={6} md={6}>
                        <div className="form__form-animated-group">
                            <span className='required_field'>* </span>  <span className="form__form-animated-group-label">Door Number</span>
                            <div className="form__form-group-field">
                                <Field name="doorNo" component={renderField} type="text" placeholder="Door Number" validate={[required]} />
                            </div>
                        </div>
                    </Col>
                </Row><Row>
                    <Col lg={6} md={6}>
                        <div className="form__form-animated-group">
                            <span className="form__form-animated-group-label">Remarks</span>
                            <div className="form__form-group-field">
                                <Field name="faxNo" component="textarea" type="text" placeholder="Remarks" />
                            </div>
                        </div>
                    </Col>
                    <Col lg={3} md={3}>
                        <div className="form__form-animated-group">
                            <div className="form__form-group">
                                <span className="required_field">* </span>{" "}
                                <span className="form__form-animated-group-label">Operational Status</span>
                                <div className="form__form-group-field">
                                    <Field
                                        name="status"
                                        component={renderToggleButtonField}
                                        defaultChecked={status}
                                    />
                                </div>
                            </div>
                        </div>
                    </Col>
                    {/* {dataInfo &&
                        <Col lg={3} md={3}>
                            <div className="form__form-animated-group">
                                <div className="form__form-group">
                                    <span className="required_field">* </span>{" "}
                                    <span className="form__form-animated-group-label">Primary Address</span>
                                    <div className="form__form-group-field">
                                        <Field
                                            name="addressType"
                                            component={renderToggleButtonField}
                                            defaultChecked={addressType}
                                        />
                                    </div>
                                </div>
                            </div>
                        </Col>
                    } */}
                </Row>
            </Col>
            <div className="form__OnboardingButton">
                <ButtonToolbar className="form__button-toolbar wizard__toolbar">
                    <Button color="primary" type="submit" className="next" onClick={handleSubmit}>Submit</Button>
                </ButtonToolbar>
            </div>
            <Modal isOpen={isModalOpen} toggle={toggleModal} style={{ maxWidth: '1000px' }}>
                <ModalHeader toggle={toggleModal}><b>Find Location</b></ModalHeader>
                <ModalBody>
                    <iframe ref={apaFrameRef} src={apaIframeUrl} width="100%" height="400px" title="Get Address" onLoad={handleMessageToIframe} style={{ width: '100%', height: '650px' }}></iframe>
                </ModalBody>
            </Modal>
        </form>

    );
};


CustomerAddOrUpdate.propTypes = {
    CustomerAddOrUpdate: PropTypes.func.isRequired,
};

const getAddressBookNameInitialValue = (dataInfo) => {
    if (dataInfo) {
        switch (dataInfo) {
            case "Home":
                return { value: 1, label: "Home" };
            case "Work":
                return { value: 2, label: "Work" };
            case "Other":
                return { value: 3, label: "Other" };
            default:
                return null;
        }
    }
    return null;
};
const mapStateToProps = (state, data) => {
    if (data && data?.dataInfo) {
        return {
            initialValues: {
                merchantCustomerId: data?.dataInfo.merchantCustomerId,
                customerName: data?.dataInfo.customerName,
                merchantCustomerCode: data?.dataInfo.merchantCustomerCode,
                buildingName: data?.dataInfo.buildingName,
                telephoneNo: data?.dataInfo.telephoneNo,
                customerContactName: data?.dataInfo.customerContactName,
                mobileNo: data?.dataInfo.mobileNo,
                latitude: data.dataInfo.latitude,
                poBoxNo: data.dataInfo.poBoxNo,
                contactName: data.dataInfo.contactName,
                doorNo: data.dataInfo.doorNo,
                floorNo: data.dataInfo.floorNo,
                addressBookName: getAddressBookNameInitialValue(data.dataInfo.addressBookName),
                faxNo: data?.dataInfo.faxNo,
                merchantCustomerAddBookId: data?.dataInfo?.merchantCustomerAddBookId,



            }
        }

    }
}

export default connect(mapStateToProps)(reduxForm({ form: 'CustomerAddOrUpdateForm', enableReinitialize: true })(CustomerAddOrUpdate))